module.exports = __webpack_public_path__ + "img/dowanzuo.dadd67a.png";